import { render, staticRenderFns } from "./Sale-modal-ticket.vue?vue&type=template&id=2f1e012d&scoped=true"
import script from "./Sale-modal-ticket.vue?vue&type=script&lang=js"
export * from "./Sale-modal-ticket.vue?vue&type=script&lang=js"
import style0 from "./Sale-modal-ticket.vue?vue&type=style&index=0&id=2f1e012d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1e012d",
  null
  
)

export default component.exports